import { observer } from "mobx-react";
import { OFTableController } from "../OFTableController";
import _ from "lodash";

const RenderSuperHeaders = observer(({ ofTableController }: { ofTableController: OFTableController }) => {
  const renderSuperHeaders = () => {
    const { superHeaders, visibleColumns } = ofTableController;

    return visibleColumns.map((col) => {
      if (col.superHeader) {
        if (col.superHeader.index === 1) {
          return (
            <div
              key={col.id}
              className="superHeader truncate flex"
              style={{ width: superHeaders[col.superHeader.id].width }}
            >
              <div className="self-center mr-auto ml-auto">{superHeaders[col.superHeader.id].title}</div>
            </div>
          );
        } else {
          return null;
        }
      }

      // Render empty holders
      return <div key={col.id} className="emptySuperHeader" style={{ width: col.width }}></div>;
    });
  };

  const renderFixedColumns = () => {
    const { visibleColumns, fixedColumns } = ofTableController;

    let pinnedColWidth = 0;

    visibleColumns.forEach((col, i) => {
      if (fixedColumns >= i + 1) {
        pinnedColWidth += col.width;
      }
    });

    return <div key="pinnedCol" className="emptySuperHeader fixed" style={{ width: pinnedColWidth }} />;
  };

  const { offsetLeft, superHeaders, showFixedCols, loadingTable } = ofTableController;

  if (_.isEmpty(superHeaders) || loadingTable) {
    return null;
  }

  return (
    <div style={{ display: "flex" }}>
      {showFixedCols && <div style={{ position: "relative", display: "flex" }}>{renderFixedColumns()}</div>}
      <div style={{ position: "relative", left: -offsetLeft, display: "flex", willChange: "transform" }}>
        {renderSuperHeaders()}
      </div>
    </div>
  );
});

export { RenderSuperHeaders };
